import _uniq from 'lodash/uniq'
import _flattenDeep from 'lodash/flattenDeep'

import getContentType from './getContentType'

export function getCategories (species, type) {
  let filteredSpecies = filterSpeciesByType(species, type)
  const categories = _uniq(
    // remove duplicates
    _flattenDeep(
      // flatten array of arrays
      filteredSpecies
        .map(item => item.fields.category) // get all the categories
        .filter(item => item) // only return categories, not undefined
        .sort() // sort alphabetically
    )
  )
  const categoriesFilters = categories.reduce((acc, category) => {
    acc[category] = true
    return acc
  }, {})
  return categoriesFilters
}

export function getColours (species, type) {
  let filteredSpecies = filterSpeciesByType(species, type)
  const colours = _uniq(
    // remove duplicates
    _flattenDeep(
      // flatten array of arrays
      filteredSpecies
        .map(item => item.fields.colour) // get all the colours
        .filter(item => item) // only return categories, not undefined
        .sort() // sort alphabetically
    )
  )
  const coloursFilters = colours.reduce((acc, colour) => {
    acc[colour] = true
    return acc
  }, {})
  return coloursFilters
}

export function getConservationStatus (species, type) {
  let filteredSpecies = filterSpeciesByType(species, type)
  const conservationStatus = _uniq(
    // remove duplicates
    _flattenDeep(
      // flatten array of arrays
      filteredSpecies
        .map(item => item.fields.conservationStatus) // get all the conservationStatus
        .filter(item => item) // only return categories, not undefined
        .sort() // sort alphabetically
    )
  )
  const conservationStatusFilters = conservationStatus.reduce(
    (acc, conservationStatus) => {
      acc[conservationStatus] = true
      return acc
    },
    {}
  )
  return conservationStatusFilters
}

export function filterSpeciesByType (species, type) {
  const filterType = item => {
    if (!type) return false
    return type.indexOf(getContentType(item)) > -1
  }
  return species.filter(item => {
    if (!filterType(item)) return false
    return true
  })
}



// WEBPACK FOOTER //
// ./src/utils/filterUtils.js